/**
 * How a node's number reads in the margin of its provision.
 *
 * All that survives of scope.ts. That module decided how much of the agreement
 * to show at once — Clause, Section or Part — and existed because the node was
 * the wrong unit: clause 10.2 has no text of its own and 11.5 is a title, so
 * reading one node at a time was less usable than the PDF it replaces. It
 * asked the reader to solve that by guessing a width.
 *
 * The provision decides it now, from the instrument's own structure, so
 * passagesFor, sectionOf, inSection and the SCOPES control are gone.
 */

/** `10.2(b)` renders in the margin as `(b)`; `24.9.1(b)(i)` as `(b)(i)`. */
export function marginLabel(number: string, opened: string): string {
  if (number === opened) return '';
  const parens = number.match(/\([^()]*\)/g);
  if (parens) return parens.join('');
  // A numbered subclause inside its provision keeps its full number, because
  // "5" alone would be ambiguous against clause 5.
  return number;
}
